import React from "react";
import PrintSafesMain from "../../Safes/PrintSafesMain";
import { Dialog } from "@material-ui/core";

export default function ShiftsPrint(props) {
    const { dataPrint, closePrint, infoPrint } = props;
    const number=dataPrint?.isLarge?15:16;
    return (
        <Dialog
            fullScreen
            open={infoPrint}
            onClose={closePrint}
        >
            <div>
                <PrintSafesMain typePrint={number} docNamePdf={"ShiftReport.pdf"} docName={"ShiftReport"}
                    dataPrint={dataPrint} closePrint={closePrint} />
            </div>
        </Dialog>
    );
}
